import React, { Suspense } from 'react';
import './App.css';
import HeaderFinal from './Navbar/HeaderFinal';
import Footer from './Pages/Footer';
import { Route, Routes } from 'react-router-dom';
import ScrollToTop from './Scroller';
import WhatsAppButton from './components/WhatsAppButton';

// Lazy load components for better performance
const HomePage = React.lazy(() => import('./components/homepage/HomePageNew'));
const Menu = React.lazy(() => import('./Pages/Menu'));
const ProductPage = React.lazy(() => import('./Pages/Product'));
const Cart = React.lazy(() => import('./Pages/Cart/Cart').then(module => ({ default: module.Cart })));
const PlaceOrder = React.lazy(() => import('./Pages/PlaceOrder/PlaceOrder').then(module => ({ default: module.PlaceOrder })));
const Verify = React.lazy(() => import('./Pages/Verify/Verify'));
const Contact = React.lazy(() => import('./components/Contact'));
const About = React.lazy(() => import('./Pages/About'));
const OrderConfirmation = React.lazy(() => import('./Pages/PlaceOrder/OrderConfirmation'));
const WishList = React.lazy(() => import('./Pages/WishList'));
const Blogs = React.lazy(() => import('./Pages/Blogs'));
const Profile = React.lazy(() => import('./Pages/Profile'));
const AddressBook = React.lazy(() => import('./Pages/AddressBook'));
const MyOrders = React.lazy(() => import('./Pages/MyOrders'));
const Returns = React.lazy(() => import('./Pages/Returns'));
const Cancellations = React.lazy(() => import('./Pages/Cancellations'));
const RegisterPopUP = React.lazy(() => import('./LoginPopup/RegisterPopUP').then(module => ({ default: module.RegisterPopUP })));
const LoginPage = React.lazy(() => import('./Pages/LoginPage').then(module => ({ default: module.LoginPage })));

// Loading component
const LoadingFallback = () => (
  <div className="flex justify-center items-center min-h-[50vh]">
    <div className="flex flex-col items-center gap-4">
      <div className="w-12 h-12 border-4 border-green-200 border-t-green-600 rounded-full animate-spin"></div>
      <p className="text-gray-600 font-medium">Loading...</p>
    </div>
  </div>
);

function App() {
  return (
    <div className='flex flex-col w-full'>
      <WhatsAppButton />
      <div className='flex justify-center z-20 items-center sticky top-0 w-full'>
        <ScrollToTop />
        <HeaderFinal />
      </div> 
      <div className='flex relative justify-center flex-col items-center h-full w-full '>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path='/' element={<HomePage/>}/>
            <Route path='/login' element={<LoginPage/>}/>
            <Route path='/register' element={<RegisterPopUP/>}/>
            <Route path='/contact' element={<Contact/>}/>
            <Route path='/about' element={<About/>}/>
            <Route path='/shop' element={<Menu />} />
            <Route path="/menu/product/:id" element={<ProductPage />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/wishlist" element={<WishList />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile/address" element={<AddressBook />} />
            <Route path="/blogs" element={<Blogs/>} />
            <Route path="/blogs/:id" element={<Blogs/>} />
            <Route path="/myorders" element={<MyOrders/>}/>
            <Route path="/orders/returns" element={<Returns/>}/>
            <Route path="/orders/cancellations" element={<Cancellations/>}/>
            <Route path="/checkout" element={<PlaceOrder />} />
            <Route path="/order-confirmation/:id" element={<OrderConfirmation />} />
            <Route path="/verify" element={<Verify/>}/>
            <Route path="/order/verify" element={<Verify />} />
          </Routes>
        </Suspense>
      </div>
      <div className='footer flex justify-center items-center b w-full'>
        <Footer />
      </div>
    </div>
  );
}

export default App;
